<template>
  <v-app>
    <div class="background-login pa-0">
      <v-row no-gutters style="height: 100vh;">
        <v-col cols="12" md="6" class="img UpAndDown" v-if="$vuetify.breakpoint.mdAndUp" align-self="center">
          <v-card elevation="0" height="100vh" color="rgba(0, 0, 0, 0)">
            <v-container fill-height fluid>
              <v-row align="center" justify="center">
                <v-col class="px-10">
                  <v-img src="@/assets/image/component/Frame-login.png" width="500px"></v-img>
                </v-col>
              </v-row>
            </v-container>
          </v-card>
        </v-col>
        <!-- <v-col cols="12" align-self="center"> -->
        <v-col cols="12" md="6" align-self="center">
          <v-main style="min-height: 100vh;">
            <Loading />
            <Alerting />
            <pmat-member-dialog></pmat-member-dialog>
            <LoadingDialog />
              <v-scroll-x-reverse-transition
                mode="out-in"
                :duration="{ enter: 100000, leave: 500 }"
                appear
              >
                <router-view />
              </v-scroll-x-reverse-transition>
            </v-main>
        </v-col>
      </v-row>
    </div>
  </v-app>
</template>

<script>
import { mapGetters } from 'vuex'
import Loading from '../components/AlertandLoading/Loading.vue'
import Alerting from '../components/AlertandLoading/Alerting.vue'
import LoadingDialog from '../components/AlertandLoading/LoadingDialog.vue'
import PmatMemberDialog from '../components/AlertandLoading/PMATMemberDialog.vue'
export default {
  name: 'MainLogin',
  components: {
    Loading,
    Alerting,
    LoadingDialog,
    PmatMemberDialog
  },

  data () {
    return {

    }
  },
  computed: {
    ...mapGetters({
      user: 'user'
    })
  },
  created () {
    if (this.$route.params.adminRef !== undefined) {
      this.loginByShareToken()
    }
  },
  methods: {
    loginByShareToken () {
      this.$store.commit('onLoading')
      const sharedToken = this.$route.params.adminRef

      this.$store
        .dispatch('loginByShareToken', {
          sharedToken
        })
        .then(() => {
          this.$store
            .dispatch('getProfileData')
            .then(() => {
              const user = this.user
              const role = user.role_id
              if (role === '1') {
                this.$router.push('/dashboard')
              } else if (role === '2') {
                // this.$store.commit('setSelectClientGroupFilter', user.client_group_id)
                this.$router.push('/dashboard')
              } else {
                this.goToLoginPage()
              }
            })
            .catch((err) =>
              this.$store.commit('onAlerting', {
                message_status: err.message,
                color: '#D1392B'
              })
            ).finally(() => this.$store.commit('offLoading'))
        })
        .catch((err) =>
          this.$store.commit('onAlerting', {
            message_status: err.message,
            color: '#D1392B'
          })
        )
    },
    goToLoginPage () {
      this.$store.commit('logout')
      if (this.$route.name !== 'Login') {
        this.$router.push('/login')
      }
    }
  }
}
</script>
<style>
@import url("https://fonts.googleapis.com/css2?family=Noto+Sans+Thai:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap");
</style>
<style scoped>
.img {
  text-align: -webkit-center;
}
.background-login {
  background-image: url("@/assets/image/component/Background-login.png");
  background-position: center center;
  background-size: cover;
}
.UpAndDown {
  animation: UpAndDown 1s infinite alternate;
}
@keyframes UpAndDown {
  0% {
    transform: translateY(0);
  }
  100% {
    transform: translateY(10px);
  }
}
</style>
